import { render, staticRenderFns } from "./student-evaluation-practice.component.vue?vue&type=template&id=6b16bc7a&scoped=true"
import script from "./student-evaluation-practice.component.vue?vue&type=script&lang=js"
export * from "./student-evaluation-practice.component.vue?vue&type=script&lang=js"
import style0 from "./student-evaluation-practice.component.vue?vue&type=style&index=0&id=6b16bc7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b16bc7a",
  null
  
)

export default component.exports